
import { useParams } from 'react-router-dom';

interface codeData {
  message: string,
  timestamp: string,
}

function JsonPage() {
  const { _id } = useParams();
  const jsonData: codeData = {
    message: 'Hello, this is JSON data from a React page!',
    timestamp: new Date().toISOString(),
  };
  return (
   <>
   <p>Data: </p> {jsonData.message} <text>, </text> {jsonData.timestamp}
   <p>Id: </p> {_id}
   </>
    


  );
}

export default JsonPage;
